import React from 'react';
import { arrayOf, func, shape, string } from 'prop-types';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';

// Utils
import { useTheme } from '@mui/material/styles';
import { VIEW_BY_OPTIONS } from '../utils/const';

import { radioButtonStyles, radioGroupStyles } from './CreateNewCommon.styles';

const PillSection = ({ typeSelection, onTypeChange, name, options }) => {
  const theme = useTheme();
  return (
    <RadioGroup onChange={onTypeChange} sx={radioGroupStyles(theme)} value={typeSelection}>
      {options.map(({ value, label }) => (
        <Box
          bgcolor={value === typeSelection ? 'secondary.light' : 'surface.white'}
          border={value === typeSelection ? 0 : 1}
          borderColor={value === typeSelection ? 'none' : 'graphic.main'}
          key={value}
          sx={radioButtonStyles(theme)}
          width="100%"
        >
          <FormControlLabel control={<Radio />} label={label} name={name} value={value} />
        </Box>
      ))}
    </RadioGroup>
  );
};

PillSection.propTypes = {
  name: string.isRequired,
  onTypeChange: func.isRequired,
  options: arrayOf(shape({ label: string.isRequired, value: string.isRequired })),
  typeSelection: string.isRequired,
};
PillSection.defaultProps = {
  options: VIEW_BY_OPTIONS,
};

export default PillSection;
